import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { Heading } from 'roo-ui/components';
import { useDialog } from 'components/Dialog';
import DummyStep from './components/DummyStep';
import StepWizard from 'components/StepWizard';
import RoomUnavailableDialog from './components/RoomUnavailableDialog';
import QuoteErrorDialog from './components/QuoteErrorDialog';

const dummyFormData = {};

const QuoteUnavailable = ({ propertyName, error }) => {
  const { Dialog } = useDialog({ initialiseOpen: true });

  return (
    <Fragment>
      <Heading.h1 mb={8}>Let&apos;s review your booking and pay</Heading.h1>
      <StepWizard collapsed formData={dummyFormData} updateFormData={noop}>
        <DummyStep title="Your Details" />
        <DummyStep title="Earn Qantas Points" />
        <DummyStep title="Payment options" />
        <DummyStep title="Confirm & Pay" />
      </StepWizard>
      <Dialog>
        {error && <QuoteErrorDialog error={error} />}
        {!error && <RoomUnavailableDialog propertyName={propertyName} />}
      </Dialog>
    </Fragment>
  );
};

QuoteUnavailable.propTypes = {
  error: PropTypes.object,
  propertyName: PropTypes.string,
};

QuoteUnavailable.defaultProps = {
  propertyName: null,
  error: null,
};

export default QuoteUnavailable;
